import React, { useEffect, useState } from "react";
import config from "../../config";
import { useUserDispatch, signOut } from "../../context/UserContext";
import { useHistory } from "react-router-dom";

// styles
import useStyles from "./styles";

// components
import PageTitle from "../../components/PageTitle/PageTitle";
import Modal from "../modals/Modal";
import {
    Table,
    TableRow,
    TableHead,
    TableBody,
    TableCell,
    TextField,
    Grid, CircularProgress
} from "@material-ui/core";
import Widget from "../../components/Widget/Widget";
import * as Icons from "@material-ui/icons";

export default function ReportCash() {
    const classes = useStyles();
    const history = useHistory();

    //global
    var userDispatch = useUserDispatch();

    const [baseUrl, setBaseUrl] = useState(config.config[0].baseUrl);
    const [showModal, setShowModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [oneThousand, setOneThousand] = useState(null);
    const [fiveHundred, setFiveHundred] = useState(null);
    const [twoHundred, setTwoHundred] = useState(null);
    const [oneHundred, setOneHundred] = useState(null);
    const [fifty, setFifty] = useState(null);
    const [twenty, setTwenty] = useState(null);
    const [ten, setTen] = useState(null);
    const [five, setFive] = useState(null);
    const [two, setTwo] = useState(null);
    const [one, setOne] = useState(null);
    const [fiftyCent, setFiftyCent] = useState(null);
    const [total, setTotal] = useState(null);
    const [today, setToday] = useState(null);
    const [vouchers, setVouchers] = useState([]);
    const [idVoucher, setIdVoucher] = useState(1);
    const [keyTableVoucher, setKeyTableVoucher] = useState(1);
    const [keyAddVoucher, setKeyAddVoucher] = useState(1);

    const closeModalLogin = e => {
        setShowModal(false);
    }

    useEffect(() => {
        const today = new Date();
        var day = "";

        if (today.getDate() < 10) {
            day = '0' + today.getDate();
        } else {
            day = today.getDate();
        }

        if ((today.getMonth() + 1) < 10) {
            setToday(day + '/0' + (today.getMonth() + 1) + '/' + today.getFullYear());
        } else {
            setToday(day + '/' + (today.getMonth() + 1) + '/' + today.getFullYear());
        }
    }, []);

    const onSubmit = async e => {
        e.preventDefault();
        setIsLoading(true);

        if (total != null || total != 0) {
            const date = new Date();
            var currentTime = date.getHours() + ':' + date.getMinutes() + ':' + date.getSeconds();

            const newReportCash = {
                idUser: localStorage.getItem("idUserSystem"), oneThousand: oneThousand == null ? 0 : oneThousand, fiveHundred: fiveHundred == null ? 0 : fiveHundred,
                twoHundred: twoHundred == null ? 0 : twoHundred, oneHundred: oneHundred == null ? 0 : oneHundred, fifty: fifty == null ? 0 : fifty,
                twenty: twenty == null ? 0 : twenty, ten: ten == null ? 0 : ten, five: five == null ? 0 : five, two: two == null ? 0 : two,
                one: one == null ? 0 : one, fiftyCent: fiftyCent == null ? 0 : fiftyCent, vouchers: vouchers, total: total, creationDate: today, creationTime: currentTime
            };

            const response = await fetch(baseUrl + "createReportCash", {
                method: 'POST',
                headers: {
                    'Accept': 'application/json', 'Content-Type': 'application/json',
                    'Authorization': localStorage.getItem("token")
                },
                body: JSON.stringify(newReportCash)
            });

            const json = await response.json();

            if (json.message == "Ok") {
                setOneThousand(null);
                setFiveHundred(null);
                setTwoHundred(null);
                setOneHundred(null);
                setFifty(null);
                setTwenty(null);
                setTen(null);
                setFive(null);
                setTwo(null);
                setOne(null);
                setFiftyCent(null);
                setTotal(null);
                setToday(null);
                signOut(userDispatch, history);
            } else {
                if (json.message == "Access is denied") {
                    setShowModal(true);
                }
            }

            setIsLoading(false);
        } else {
            setIsLoading(false);
        }
    }

    const onChange = (property) => (event) => {
        var value = event.target.value;

        switch (property) {
            case 1:
                setOneThousand(value);
                break;
            case 2:
                setFiveHundred(value);
                break;
            case 3:
                setTwoHundred(value);
                break;
            case 4:
                setOneHundred(value);
                break;
            case 5:
                setFifty(value);
                break;
            case 6:
                setTwenty(value);
                break;
            case 7:
                setTen(value);
                break;
            case 8:
                setFive(value);
                break;
            case 9:
                setTwo(value);
                break;
            case 10:
                setOne(value);
                break;
            case 11:
                setFiftyCent(value);
                break;
        }

        calculateTotal();
    }

    const onChangeVoucherAmount = (property) => (event) => {
        var value = event.target.value;

        for (var i = 0; i < vouchers.length; i++) {
            var item = vouchers[i];
            var indexVoucher = vouchers.indexOf(item);

            if (item.id == property) {
                var voucher = {
                    id: item.id,
                    amount: value,
                    transaction: item.transaction
                }

                const allList = vouchers;
                allList[indexVoucher] = voucher;
                setVouchers(allList);
                i = vouchers.length;
            }
        }

        setKeyAddVoucher(keyAddVoucher + 1);
        calculateTotal();
    }

    const onChangeVoucherTransaction = (property) => (event) => {
        var value = event.target.value;

        for (var i = 0; i < vouchers.length; i++) {
            var item = vouchers[i];
            var indexVoucher = vouchers.indexOf(item);

            if (item.id == property) {
                var voucher = {
                    id: item.id,
                    amount: item.amount,
                    transaction: value
                }

                const allList = vouchers;
                allList[indexVoucher] = voucher;
                setVouchers(allList);
                i = vouchers.length;
            }
        }

        setKeyAddVoucher(keyAddVoucher + 1);
    }

    const onDeleteVoucher = (property) => (event) => {
        if (vouchers.length == 1) {
            setVouchers([]);

            var value = 0;

            if (oneThousand != null && oneThousand > 0) {
                value = value + (oneThousand * 1000);
            }
            if (fiveHundred != null && fiveHundred > 0) {
                value = value + (fiveHundred * 500);
            }
            if (twoHundred != null && twoHundred > 0) {
                value = value + (twoHundred * 200);
            }
            if (oneHundred != null && oneHundred > 0) {
                value = value + (oneHundred * 100);
            }
            if (fifty != null && fifty > 0) {
                value = value + (fifty * 50);
            }
            if (twenty != null && twenty > 0) {
                value = value + (twenty * 20);
            }
            if (ten != null && ten > 0) {
                value = value + (ten * 10);
            }
            if (five != null && five > 0) {
                value = value + (five * 5);
            }
            if (two != null && two > 0) {
                value = value + (two * 2);
            }
            if (one != null && one > 0) {
                value = value + (one * 1);
            }
            if (fiftyCent != null && fiftyCent > 0) {
                value = value + (fiftyCent * .5);
            }

            setTotal(value);
        } else {
            var indexVoucher = -1;

            vouchers.map((item) => {
                if (item.id == property) {
                    indexVoucher = vouchers.indexOf(item);
                }
            });

            if (indexVoucher > -1) {
                var list = [];
                for (var i = 0; i < vouchers.length; i++) {
                    var item = vouchers[i];
                    if (indexVoucher != i) {
                        list.push(item);
                    }
                }
                setVouchers(list);

                var value = 0;

                if (oneThousand != null && oneThousand > 0) {
                    value = value + (oneThousand * 1000);
                }
                if (fiveHundred != null && fiveHundred > 0) {
                    value = value + (fiveHundred * 500);
                }
                if (twoHundred != null && twoHundred > 0) {
                    value = value + (twoHundred * 200);
                }
                if (oneHundred != null && oneHundred > 0) {
                    value = value + (oneHundred * 100);
                }
                if (fifty != null && fifty > 0) {
                    value = value + (fifty * 50);
                }
                if (twenty != null && twenty > 0) {
                    value = value + (twenty * 20);
                }
                if (ten != null && ten > 0) {
                    value = value + (ten * 10);
                }
                if (five != null && five > 0) {
                    value = value + (five * 5);
                }
                if (two != null && two > 0) {
                    value = value + (two * 2);
                }
                if (one != null && one > 0) {
                    value = value + (one * 1);
                }
                if (fiftyCent != null && fiftyCent > 0) {
                    value = value + (fiftyCent * .5);
                }

                var amountVoucher = 0;
                list.map((item) => {
                    amountVoucher = Number(amountVoucher) + Number(item.amount);
                });

                value = Number(value) + Number(amountVoucher);
                setTotal(value);
            }
        }

        setKeyTableVoucher(keyTableVoucher + 1);
    }

    const onAddVoucher = e => {
        var voucher = {
            id: idVoucher,
            amount: null,
            transaction: null
        }

        var voucherList = vouchers;
        voucherList.push(voucher);
        setVouchers(voucherList);
        setIdVoucher(idVoucher + 1);
    }

    function calculateTotal() {
        var value = 0;

        if (oneThousand != null && oneThousand > 0) {
            value = value + (oneThousand * 1000);
        }
        if (fiveHundred != null && fiveHundred > 0) {
            value = value + (fiveHundred * 500);
        }
        if (twoHundred != null && twoHundred > 0) {
            value = value + (twoHundred * 200);
        }
        if (oneHundred != null && oneHundred > 0) {
            value = value + (oneHundred * 100);
        }
        if (fifty != null && fifty > 0) {
            value = value + (fifty * 50);
        }
        if (twenty != null && twenty > 0) {
            value = value + (twenty * 20);
        }
        if (ten != null && ten > 0) {
            value = value + (ten * 10);
        }
        if (five != null && five > 0) {
            value = value + (five * 5);
        }
        if (two != null && two > 0) {
            value = value + (two * 2);
        }
        if (one != null && one > 0) {
            value = value + (one * 1);
        }
        if (fiftyCent != null && fiftyCent > 0) {
            value = value + (fiftyCent * .5);
        }

        var amountVoucher = 0;
        vouchers.map((item) => {
            amountVoucher = Number(amountVoucher) + Number(item.amount);
        });

        value = Number(value) + Number(amountVoucher);
        setTotal(value);
    }

    return (
        <>
            <div>
                {showModal ? (
                    <Modal
                        isOpen={showModal}
                        closeModal={closeModalLogin}
                    />
                ) : (
                    <></>
                )}
                <PageTitle title="Reporte de caja" />

                <div className={classes.divHeader} >
                    <p className={classes.labelTitle}>{"Cajero: " + localStorage.getItem("name") ?? ""}</p>
                    <p className={classes.labelTitle}>{"Fecha: " + today}</p>
                </div>

                <Grid item xs={12}>
                    <Widget
                        noBodyPadding
                        bodyClass={classes.tableWidget}
                    >
                        <Table className="mb-0">
                            <TableHead>
                                <TableRow className={classes.root} >
                                    <TableCell>DENOMINACIÓN</TableCell>
                                    <TableCell>CANTIDAD</TableCell>
                                    {/*{keys.map(key => (
                                    <TableCell key={key}>{key}</TableCell>
                                ))}*/}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableRow>
                                    <TableCell className={classes.tableRowStyle} >$ 1,000</TableCell>
                                    <TableCell className={classes.tableRowStyle} >
                                        <TextField
                                            InputProps={{
                                                classes: {
                                                    focused: classes.textBorderMembership,
                                                    input: classes.inputMembership,
                                                },
                                                inputProps: {
                                                    min: 0
                                                }
                                            }}
                                            value={oneThousand}
                                            onChange={onChange(1)}
                                            onKeyUp={onChange(1)}
                                            onBlur={onChange(1)}
                                            placeholder={"0"}
                                            type={"number"}
                                            onKeyDown={(evt) => evt.key === 'e' && evt.preventDefault()}
                                            style={{ width: '100%' }}
                                            inputStyle={{ width: '100%' }}
                                        />
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell className={classes.tableRowStyle} >$ 500</TableCell>
                                    <TableCell className={classes.tableRowStyle} >
                                        <TextField
                                            InputProps={{
                                                classes: {
                                                    focused: classes.textBorderMembership,
                                                    input: classes.inputMembership,
                                                },
                                                inputProps: {
                                                    min: 0
                                                }
                                            }}
                                            value={fiveHundred}
                                            onChange={onChange(2)}
                                            onKeyUp={onChange(2)}
                                            onBlur={onChange(2)}
                                            placeholder={"0"}
                                            type={"number"}
                                            onKeyDown={(evt) => evt.key === 'e' && evt.preventDefault()}
                                            style={{ width: '100%' }}
                                            inputStyle={{ width: '100%' }}
                                        />
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell className={classes.tableRowStyle} >$ 200</TableCell>
                                    <TableCell className={classes.tableRowStyle} >
                                        <TextField
                                            InputProps={{
                                                classes: {
                                                    focused: classes.textBorderMembership,
                                                    input: classes.inputMembership,
                                                },
                                                inputProps: {
                                                    min: 0
                                                }
                                            }}
                                            value={twoHundred}
                                            onChange={onChange(3)}
                                            onKeyUp={onChange(3)}
                                            onBlur={onChange(3)}
                                            placeholder={"0"}
                                            type={"number"}
                                            onKeyDown={(evt) => evt.key === 'e' && evt.preventDefault()}
                                            style={{ width: '100%' }}
                                            inputStyle={{ width: '100%' }}
                                        />
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell className={classes.tableRowStyle} >$ 100</TableCell>
                                    <TableCell className={classes.tableRowStyle} >
                                        <TextField
                                            InputProps={{
                                                classes: {
                                                    focused: classes.textBorderMembership,
                                                    input: classes.inputMembership,
                                                },
                                                inputProps: {
                                                    min: 0
                                                }
                                            }}
                                            value={oneHundred}
                                            onChange={onChange(4)}
                                            onKeyUp={onChange(4)}
                                            onBlur={onChange(4)}
                                            placeholder={"0"}
                                            type={"number"}
                                            onKeyDown={(evt) => evt.key === 'e' && evt.preventDefault()}
                                            style={{ width: '100%' }}
                                            inputStyle={{ width: '100%' }}
                                        />
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell className={classes.tableRowStyle} >$ 50</TableCell>
                                    <TableCell className={classes.tableRowStyle} >
                                        <TextField
                                            InputProps={{
                                                classes: {
                                                    focused: classes.textBorderMembership,
                                                    input: classes.inputMembership,
                                                },
                                                inputProps: {
                                                    min: 0
                                                }
                                            }}
                                            value={fifty}
                                            onChange={onChange(5)}
                                            onKeyUp={onChange(5)}
                                            onBlur={onChange(5)}
                                            placeholder={"0"}
                                            type={"number"}
                                            onKeyDown={(evt) => evt.key === 'e' && evt.preventDefault()}
                                            style={{ width: '100%' }}
                                            inputStyle={{ width: '100%' }}
                                        />
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell className={classes.tableRowStyle} >$ 20</TableCell>
                                    <TableCell className={classes.tableRowStyle} >
                                        <TextField
                                            InputProps={{
                                                classes: {
                                                    focused: classes.textBorderMembership,
                                                    input: classes.inputMembership,
                                                },
                                                inputProps: {
                                                    min: 0
                                                }
                                            }}
                                            value={twenty}
                                            onChange={onChange(6)}
                                            onKeyUp={onChange(6)}
                                            onBlur={onChange(6)}
                                            placeholder={"0"}
                                            type={"number"}
                                            onKeyDown={(evt) => evt.key === 'e' && evt.preventDefault()}
                                            style={{ width: '100%' }}
                                            inputStyle={{ width: '100%' }}
                                        />
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell className={classes.tableRowStyle} >$ 10</TableCell>
                                    <TableCell className={classes.tableRowStyle} >
                                        <TextField
                                            InputProps={{
                                                classes: {
                                                    focused: classes.textBorderMembership,
                                                    input: classes.inputMembership,
                                                },
                                                inputProps: {
                                                    min: 0
                                                }
                                            }}
                                            value={ten}
                                            onChange={onChange(7)}
                                            onKeyUp={onChange(7)}
                                            onBlur={onChange(7)}
                                            placeholder={"0"}
                                            type={"number"}
                                            onKeyDown={(evt) => evt.key === 'e' && evt.preventDefault()}
                                            style={{ width: '100%' }}
                                            inputStyle={{ width: '100%' }}
                                        />
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell className={classes.tableRowStyle} >$ 5</TableCell>
                                    <TableCell className={classes.tableRowStyle} >
                                        <TextField
                                            InputProps={{
                                                classes: {
                                                    focused: classes.textBorderMembership,
                                                    input: classes.inputMembership,
                                                },
                                                inputProps: {
                                                    min: 0
                                                }
                                            }}
                                            value={five}
                                            onChange={onChange(8)}
                                            onKeyUp={onChange(8)}
                                            onBlur={onChange(8)}
                                            placeholder={"0"}
                                            type={"number"}
                                            onKeyDown={(evt) => evt.key === 'e' && evt.preventDefault()}
                                            style={{ width: '100%' }}
                                            inputStyle={{ width: '100%' }}
                                        />
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell className={classes.tableRowStyle} >$ 2</TableCell>
                                    <TableCell className={classes.tableRowStyle} >
                                        <TextField
                                            InputProps={{
                                                classes: {
                                                    focused: classes.textBorderMembership,
                                                    input: classes.inputMembership,
                                                },
                                                inputProps: {
                                                    min: 0
                                                }
                                            }}
                                            value={two}
                                            onChange={onChange(9)}
                                            onKeyUp={onChange(9)}
                                            onBlur={onChange(9)}
                                            placeholder={"0"}
                                            type={"number"}
                                            onKeyDown={(evt) => evt.key === 'e' && evt.preventDefault()}
                                            style={{ width: '100%' }}
                                            inputStyle={{ width: '100%' }}
                                        />
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell className={classes.tableRowStyle} >$ 1</TableCell>
                                    <TableCell className={classes.tableRowStyle} >
                                        <TextField
                                            InputProps={{
                                                classes: {
                                                    focused: classes.textBorderMembership,
                                                    input: classes.inputMembership,
                                                },
                                                inputProps: {
                                                    min: 0
                                                }
                                            }}
                                            value={one}
                                            onChange={onChange(10)}
                                            onKeyUp={onChange(10)}
                                            onBlur={onChange(10)}
                                            placeholder={"0"}
                                            type={"number"}
                                            onKeyDown={(evt) => evt.key === 'e' && evt.preventDefault()}
                                            style={{ width: '100%' }}
                                            inputStyle={{ width: '100%' }}
                                        />
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell className={classes.tableRowStyleBorder} >$ .5</TableCell>
                                    <TableCell className={classes.tableRowStyleBorder} >
                                        <TextField
                                            InputProps={{
                                                classes: {
                                                    focused: classes.textBorderMembership,
                                                    input: classes.inputMembership,
                                                },
                                                inputProps: {
                                                    min: 0
                                                }
                                            }}
                                            value={fiftyCent}
                                            onChange={onChange(11)}
                                            onKeyUp={onChange(11)}
                                            onBlur={onChange(11)}
                                            placeholder={"0"}
                                            type={"number"}
                                            onKeyDown={(evt) => evt.key === 'e' && evt.preventDefault()}
                                            style={{ width: '100%' }}
                                            inputStyle={{ width: '100%' }}
                                        />
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell key={idVoucher} className={classes.tableRowStyleTitle} >Vouchers</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                        {vouchers.length == 0 ? (
                            <>
                                <div className={classes.divAddButton} >
                                    <Icons.Add classes={{ root: classes.searchIcon }}
                                        onClick={onAddVoucher}
                                    />
                                </div>
                            </>
                        ) : (
                            <>
                                <Table className="mb-0" key={keyTableVoucher}>
                                    <TableHead>
                                        <TableRow className={classes.root} >
                                            <TableCell>IMPORTE</TableCell>
                                            <TableCell># TRANSACCIÓN</TableCell>
                                            <TableCell style={{ textAlign: 'center' }}>ELIMINAR</TableCell>
                                            {/*{keys.map(key => (
                                                <TableCell key={key}>{key}</TableCell>
                                            ))}*/}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {vouchers.map(({ id, amount, transaction }) => (
                                            <TableRow>
                                                <TableCell className={classes.tableRowStyle} >
                                                    <TextField
                                                        InputProps={{
                                                            classes: {
                                                                focused: classes.textBorderMembership,
                                                                input: classes.inputMembership,
                                                            },
                                                            inputProps: {
                                                                min: 0
                                                            }
                                                        }}
                                                        value={amount}
                                                        onChange={onChangeVoucherAmount(id)}
                                                        //onKeyUp={onChangeVoucherAmount(id)}
                                                        //onBlur={onChangeVoucherAmount(id)}
                                                        placeholder={"0"}
                                                        type={"number"}
                                                        onKeyDown={(evt) => evt.key === 'e' && evt.preventDefault()}
                                                        style={{ width: '100%' }}
                                                        inputStyle={{ width: '100%' }}
                                                    />
                                                </TableCell>
                                                <TableCell className={classes.tableRowStyle} >
                                                    <TextField
                                                        InputProps={{
                                                            classes: {
                                                                focused: classes.textBorderMembership,
                                                                input: classes.inputMembership,
                                                            },
                                                            inputProps: {
                                                                min: 0
                                                            }
                                                        }}
                                                        value={transaction}
                                                        onChange={onChangeVoucherTransaction(id)}
                                                        //onKeyUp={onChangeVoucherTransaction(id)}
                                                        //onBlur={onChangeVoucherTransaction(id)}
                                                        placeholder={"0"}
                                                        type={"number"}
                                                        onKeyDown={(evt) => evt.key === 'e' && evt.preventDefault()}
                                                        style={{ width: '100%' }}
                                                        inputStyle={{ width: '100%' }}
                                                    />
                                                </TableCell>
                                                <TableCell className={classes.tableRowStyleTitle} >
                                                    <div className={classes.divDeleteButton} >
                                                        <Icons.Delete classes={{ root: classes.searchIcon }}
                                                            onClick={onDeleteVoucher(id)}
                                                        />
                                                    </div>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                        <TableRow>
                                            <TableCell className={classes.tableRowStyleTitle} >
                                                <div className={classes.divAddButton} key={keyAddVoucher}>
                                                    <Icons.Add classes={{ root: classes.searchIcon }}
                                                        onClick={onAddVoucher}
                                                    />
                                                </div>
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </>
                        )}
                        <br />
                    </Widget>
                </Grid>

                {total == null || total == 0 ? (
                    <div style={{ display: "flex", float: "right", marginBottom: "80px" }} >
                        <p className={classes.labelTitle} >{"Total: $ 0"}</p>
                    </div>
                ) : (
                    <div style={{ display: "flex", float: "right", marginBottom: "80px" }} >
                        <p className={classes.labelTitle} >{"Total: $ " + total}</p>
                    </div>
                )}

                <div className={classes.divButton}>
                    {isLoading ? (
                        <CircularProgress size={26} className={classes.loginLoader} />
                    ) : (
                        <button
                            className={total == null || total == 0
                                ? classes.disableButton : classes.enableButton}
                            disabled={(total == null || total == 0)}
                            onClick={onSubmit}
                        >Guardar</button>
                    )}
                </div>
            </div>
        </>
    );
}
